import * as React from "react";
import MainPanelRefreshContext from "./provider";

export default function useMainPanelRefresh() {
  return React.useContext(MainPanelRefreshContext);
}
